import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SectionTitle from '../SectionTitle/SectionTitle';
import Pimg1 from '../../images/partners/1.png';
import Pimg2 from '../../images/partners/2.png';
import Pimg3 from '../../images/partners/3.png';
import Pimg4 from '../../images/partners/4.png';
import Pimg5 from '../../images/partners/5.png';
import Pimg6 from '../../images/partners/6.png';
import Pimg7 from '../../images/partners/7.png';
import Pimg8 from '../../images/partners/8.png';
import Pimg9 from '../../images/partners/9.png';
import Pimg10 from '../../images/partners/10.png';
import Pimg11 from '../../images/partners/11.png';
    
const PartnersSection = (props) => {
    const { SectionTitleShow = true } = props;
    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };


    return (
        <section className="partners-section " style={{ marginTop: '150px' }}>
            <h2 className="hidden">Partners</h2>
            <div className="container">
                {SectionTitleShow && (
                    <div className="row">
                        <SectionTitle subtitle={'Partenaires de Confiance'} title={'Nos'} titleColor={'Partenaires'} />
                    </div>
                )}
                <div className="row align-items-center">
                 
                    <div className={"" +props.CollClass}>
                        <div className="partner-grids partners-slider">
                            <Slider {...settings}>
                                <div className="grid">
                                    <img src={Pimg1} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg2} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg3} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg4} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg5} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg6} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg7} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg8} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg9} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg10} alt="Partner Logo" />
                                </div>
                                <div className="grid">
                                    <img src={Pimg11} alt="Partner Logo" />
                                </div>  
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PartnersSection;